import { render, staticRenderFns } from "./LegendMap.vue?vue&type=template&id=b310f2c2&scoped=true"
import script from "./LegendMap.vue?vue&type=script&lang=js"
export * from "./LegendMap.vue?vue&type=script&lang=js"
import style0 from "./LegendMap.vue?vue&type=style&index=0&id=b310f2c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b310f2c2",
  null
  
)

export default component.exports